/**
 * Read a cursor-paginated list to the end, or until `maxPages` pages.
 *
 * Pages are fetched one after another: each request needs the previous page's
 * cursor, so they cannot run in parallel. `truncated` says the page cap
 * stopped the read while the server still had more.
 */
export async function drainCursorPages<T>(
  fetchPage: (
    cursor: string | undefined
  ) => Promise<{ data: T[]; pagination: { next_cursor: string | null } }>,
  maxPages: number
): Promise<{ rows: T[]; truncated: boolean }> {
  const rows: T[] = []
  let cursor: string | undefined
  let pageCount = 0
  do {
    // eslint-disable-next-line no-await-in-loop
    const page = await fetchPage(cursor)
    rows.push(...page.data)
    pageCount += 1
    cursor = page.pagination.next_cursor ?? undefined
  } while (cursor && pageCount < maxPages)
  return { rows, truncated: Boolean(cursor) }
}
